import { render, staticRenderFns } from "./CustomSurveysSurvey.vue?vue&type=template&id=8dea94fa&scoped=true&"
import script from "./CustomSurveysSurvey.vue?vue&type=script&lang=js&"
export * from "./CustomSurveysSurvey.vue?vue&type=script&lang=js&"
import style0 from "./CustomSurveysSurvey.vue?vue&type=style&index=0&id=8dea94fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dea94fa",
  null
  
)

export default component.exports